import api from '../utils/api';

const tagsService = {
  // Paleta de cores
  getTagColors: async () => {
    const response = await api.get('/companies/tag_colors');
    return response.data;
  },

  // Tags da empresa
  getCompanyTags: async (includeArchived = false) => {
    const params = includeArchived ? { include_archived: true } : {};
    const response = await api.get('/companies/tags', { params });
    return response.data;
  },

  createCompanyTag: async (name, colorHex) => {
    const response = await api.post('/companies/tags', {
      tag: {
        name,
        color_hex: colorHex,
      },
    });
    return response.data;
  },

  updateCompanyTag: async (tagId, name, colorHex) => {
    const response = await api.put(`/companies/tags/${tagId}`, {
      tag: {
        name,
        color_hex: colorHex,
      },
    });
    return response.data;
  },

  archiveTag: async (tagId) => {
    const response = await api.post(`/companies/tags/${tagId}/archive`);
    return response.data;
  },

  unarchiveTag: async (tagId) => {
    const response = await api.post(`/companies/tags/${tagId}/unarchive`);
    return response.data;
  },

  // Tags de talentos
  getTalentTags: async (talentId) => {
    const response = await api.get(`/companies/talents/${talentId}/tags`);
    return response.data;
  },

  addTagToTalent: async (talentId, tagId) => {
    const response = await api.post(`/companies/talents/${talentId}/tags`, {
      tag_id: tagId,
    });
    return response.data;
  },

  removeTagFromTalent: async (talentId, tagId) => {
    const response = await api.delete(`/companies/talents/${talentId}/tags/${tagId}`);
    return response.data;
  },
};

export default tagsService;

